<template>
    <div class="main-container">
      <div class="container">
        <!-- Header Section -->
        <div class="row">
          <div class="col-lg-12 text-center my-4">
            <h1>About Us</h1>
            
          </div>
        </div>
  
        
        <div class="row">
          <div class="col-lg-12">
            <p class="text-white">
            Cenderawasih Juara Manajemen, Established in 2024, we are a premier sports event promoter dedicated to delivering exceptional experiences for fans and participants alike. With a commitment to professionalism, innovation, and the spirit of sportsmanship, we organize a wide range of events, from local tournaments to national and international competitions.
            </p>
            <p class="text-white">
            We believe that sports are a powerful platform for building communities, inspiring generations, and promoting a healthy lifestyle. Through excellent event management and strategic partnerships, we create unforgettable moments while making a positive impact on the world of sports.
            </p>  
            <p class="text-white">
            Join us and experience the thrill of sports like never before!
            </p>  
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AboutPage',
  };
  </script>
  
  <style scoped>
  
  
  .schedule-table {
    width: 100%;
    margin-top: 20px;
    border-color: #444; /* Darker border color */
  }
  
  .table {
    background-color: #181818; /* Dark table background */
    color: #fff; /* White text for table content */
  }
  
  .table thead {
    background-color: #333; /* Slightly darker header for the table */
  }
  
  .table tbody tr:hover {
    background-color: #444; /* Dark gray background on hover */
  }
  </style>
  